import React from 'react'
import Header from './Header'
import { Link } from 'react-router-dom'

function About() {
  return (
    <div>
        <>
        <Header/>
  <section className="page-header">
    <div className="container">
      <div className="page-header-info">
        <h4>About Us!</h4>
        <h2>
        About Safe & Reliable Transportation<br/> | Your Trusted Trucking Partner  
          <br />  
        </h2>
        <p>
          
Safe and Reliable Transportation began with a single truck,<br/>
 a relentless work ethic, and a vision to redefine what it means <br/>
 to be a trucking partner. Founded by industry veterans who grew<br/>
  tired of empty promises and delayed shipments, we set out to <br/>  
  build a company where actions speak louder than words.  <br/>

What started as a modest operation has blossomed into a nationwide<br/>
 leader in freight logistics. But no matter how much we grow, our focus <br/>
 remains unchanged: to treat every shipment as if it’s our own. From the <br/>
 first mile to the last, we prioritize what matters most—your cargo’s safety,<br/>
 your timeline’s integrity, and your peace of mind.
        </p>
      </div>
    </div>
  </section>
  {/*page-header*/}
  <section className="about-section padding mb-5">
    <div className="container">
      <div className="row">
        <div className="col-lg-5">
          <div className="about-img-wrap mt-50">
            <img
              className="wow fade-in-left"
              data-wow-delay="100ms"
              src="images/content-bg-1.jpg"
              alt="img"
            />
            <img
              className="wow fade-in-bottom"
              data-wow-delay="300ms"
              src="images/refrence.jpeg"
              alt="img"
            />
          </div>
        </div>
        <div className="col-lg-7">
          <div className="section-heading mb-40">
            <h3 className="sub-heading is-border border-anim">
              Trusted Path to Global Shipping!
              <span className="sh-underline">
                <img className="sh-truck" src="images/truck.svg" alt="truck" />
              </span>
            </h3>
            <h2
              className="text-anim"
              data-effect="fade-in-right"
              data-split="char"
              data-delay="0.3"
              data-duration={1}
            >
              {" "}
              What defines  <span className="hl">us!</span>
            </h2>
            <p
              className="text-anim"
              data-effect="fade-in-bottom"
              data-ease="power4.out"
            >
Safety isn’t a checkbox—it’s the foundation of everything we do. Our drivers are handpicked for their expertise, professionalism, and commitment to best practices. They undergo continuous training in:  

Our fleet is equipped with state-of-the-art technology, including collision avoidance systems and real-time diagnostics, ensuring every trailer meets stringent safety standards. We’re proud to hold DOT certifications and maintain rigorous maintenance schedules, because your cargo deserves nothing less than perfection.              </p>
          </div>
          <div className="btn-group wow fade-in-bottom" data-wow-delay="300ms">
          <a href='tel:"3017097924"'>  <div className="call-info">
                    <i className="fa-solid fa-phone" />
                    <h3>
                      Have Any Questions?{" "}
                      <span>(301) 709-7924</span>
                    </h3>
                  </div></a>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/*/.about-section*/}
  <section className="about-section padding ">
    <div className="container">
      <div className="row">
        <div className="col-lg-7">
          <div className="section-heading mb-40">
            <h3 className="sub-heading is-border border-anim">
            Simple, safe, and stress-free 
              <span className="sh-underline">
                <img className="sh-truck" src="images/truck.svg" alt="truck" />
              </span>
            </h3>
            <h2
              className="text-anim"
              data-effect="fade-in-left"
              data-split="char"
              data-delay="0.3"
              data-duration={1}
            >
              {" "}
              Reliability Rooted in Experience <span className="hl"></span>
            </h2>
            <p
              className="text-anim"
              data-effect="fade-in-bottom"
              data-ease="power4.out"
            >
              In trucking, reliability isn’t just about speed—it’s about consistency. Over the years, we’ve honed our logistics strategies to anticipate challenges before they arise. Our team of dispatchers and planners work around the clock, leveraging real-time data and industry expertise to navigate traffic, weather, and road closures.  

When you partner with us, you’re not just hiring a trucking service—you’re gaining a team that treats your deadlines as sacred.  
Behind every successful delivery is a team of dedicated professionals. Our drivers, many of whom have spent decades on the road, bring unmatched knowledge of North America’s highways. They’re supported by logistics specialists, customer service advocates, and maintenance crews who share one goal: making your freight move smoothly.  

            </p>
          </div>
        </div>
        <div className="col-lg-5">
          <div className="about-img-wrap mt-50">
            <img
              className="wow fade-in-right"
              data-wow-delay="100ms"
              src="images/content-bg-2.jpg"
              alt="img"
            />
            <img
              className="wow fade-in-bottom"
              data-wow-delay="300ms"
              src="images/post-3.jpg"
              alt="img"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="about-section padding mb-5">
    <div className="container">
      <div className="row">
        <div className="col-lg-5">
          <div className="about-img-wrap mt-50">
            <img
              className="wow fade-in-left"
              data-wow-delay="100ms"
              src="images/content-bg-8.jpg"
              alt="img"
            />
            <img
              className="wow fade-in-bottom"
              data-wow-delay="300ms"
              src="images/post-5.jpg"
              alt="img"
            />
          </div>
        </div>
        <div className="col-lg-7">
          <div className="section-heading mb-40">
            <h3 className="sub-heading is-border border-anim">
            Your Freight, Our Legacy
              <span className="sh-underline">
                <img className="sh-truck" src="images/truck.svg" alt="truck" />
              </span>
            </h3>
            <h2
              className="text-anim"
              data-effect="fade-in-right"
              data-split="char"
              data-delay="0.3"
              data-duration={1}
            >
              {" "}
              OUR <span className="hl">MISSION!</span>
            </h2>
            <p
              className="text-anim"
              data-effect="fade-in-bottom"
              data-ease="power4.out"
            >
              “To be the trucking partner you never have to worry about.”  <br/>

This philosophy drives every decision we make. Whether it’s investing in eco-friendly technologies to reduce emissions or offering flexible scheduling for urgent shipments, we’re committed to simplifying logistics for businesses like yours.  
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
 <footer className="footer-section">
    <div className="map-pattern" />
    <div className="footer-wrapper">
      <div className="container">
        <div className="row gy-lg-0 gy-4">
          <div className="col-lg-3 col-md-6">
            <div className="footer-widget">
              <Link to="/" className="footer-logo">
                <img src="images/logo.png" alt="logo" />
              </Link>
              <p>
              Safe and Reliable Transportation specializes in efficient
                transport warehousing and distribution of goods.
              </p>
              <ul className="social-share">
                <li>
                   <a href="https://www.facebook.com/profile.php?id=61575268596055">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                </li>
          
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="footer-widget widget-links">
              <div className="widget-title">
                <h3>Company</h3>
              </div>
              <ul className="footer-links">
                <li>
                  <Link to="/aboutus">About Us</Link>
                </li>
                <li>
                  <Link to="/services">Our Services</Link>
                </li>
                <li>
                  <Link to="/testimonials">Testimonials</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                <li>
                        <a href="https://apply.srtranspor.com/login/driver">Driver Login</a>
                      </li>
                      <li>
                        <a href="https://apply.srtranspor.com/login/company">Customer Login</a>
                      </li>
                      <li>
                        <Link to="/resources">Resources</Link>
                      </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="footer-widget">
              <div className="widget-title">
                <h3>Get In Touch</h3>
              </div>
              <ul className="footer-contact-info">
                <li>
                  <p>
                    <span>Address:</span>9528 Baltimore, Ave
Laurel, MD 20723
                  </p>
                </li>
                <li>
                  <p>
                    <span>Mail Us:</span>humanresource@srtranspor.com
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="footer-widget">
              <div className="widget-title">
                <h3>Newslatter Signup</h3>
              </div>
              <form action="#" className="subscribe-form" noValidate="true">
                <div className="mc-fields">
                  <input
                    className="form-control"
                    type="email"
                    name="EMAIL"
                    placeholder="Your Email"
                    required=""
                  />
                  <input
                    type="hidden"
                    name="action"
                    defaultValue="mailchimpsubscribe"
                  />
                  <button className="submit">
                    <i className="fa-regular fa-arrow-right-long" />
                  </button>
                </div>
                <div className="clearfix" />
                <div id="subscribe-result">
                  <div className="subscription-success" />
                  <div className="subscription-error" />
                </div>
              </form>
              <p className="mt-20">
                Subscribe us and get all the benifits from today.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="running-truck">
        <div className="truck" />
        <div className="truck-2" />
        <div className="truck-3" />
      </div>
    </div>
    <div className="copyright-area">
      <span id="currentYear"> </span> © Safe and Reliable Transportation,
      All Rights Reserved.
    </div>
  </footer>
  <div id="scrollup">
    <button id="scroll-top" className="scroll-to-top">
      <i className="fa-regular fa-arrow-up" />
    </button>
  </div>
</>

    </div>
  )
}

export default About
